// src/components/molecules/UserProfile/Edit/ProfilePicture/ProfilePictureControls.js

import React from "react";
import { Grid, IconButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ImageUploader from "../ProfilePicture/ImageUploader";

const ProfilePictureControls = ({ handleRemoveProfilePicture, onImageUpload, userId }) => {
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <ImageUploader onImageUpload={onImageUpload} userId={userId} />
      </Grid>
      <Grid item>
        <IconButton
          color="secondary"
          onClick={handleRemoveProfilePicture}
          sx={{
            border: "1px solid",
            borderColor: "white",
            borderRadius: 1,
          }}
        >
          <DeleteOutlineIcon sx={{ color: "white" }} />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default ProfilePictureControls;
